import { Http, Response, Headers, RequestOptions }
  from '@angular/http';
import { Inject, Injector, Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {HttpHandlerService} from "./httpHandler.service";
import {CacheUtilService} from "./cache-util/CacheUtilService";
import {AlertService} from "./alert/alert.service";
import {IAppConfig} from "../models/app-config.model";
import {AppConfig} from "./app.config";


@Injectable()
export class BaseHttpService {

  public pendingRequests = 0;
  public accountCachKey = "accountKey";
  public loggedInCachKey = "isLoggedIn";
  public lastAccountCheckDate="lastAccountCheckDate";

  constructor(private http:Http, private alertService:AlertService, private cachUtil:CacheUtilService, private httpHandlerService:HttpHandlerService) {
    var injector:Injector = window["Injector"];
    //cachUtil=injector.get(CacheUtilService);
    //http = injector.get(Http);

    //
    //this.httpHandlerService = injector.get(HttpHandlerService);
  }

  public  hasPendingRequest() {

    return this.pendingRequests > 0;
  }

  public setOption() {

    let token = this.cachUtil.getFromCach('jhi-authenticationToken');
    let headers = new Headers({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Headers': '*',
      'Access-Control-Allow-Origin': '*'
    });
    if (token != null) {
      token = 'Bearer ' + token.id_token;
      headers = new Headers({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'Authorization': token

      });
    }
    let options = new RequestOptions({headers: headers});
    return options;
  }

  public post(url:string, data:any) {

    this.pendingRequests++;
    let options = this.setOption();
    return this.http.post(url, data, options)
      .map((res:any) => this.extractData(res, false, true))
      .catch((error)=> {
        return this.handleError(error, this.httpHandlerService)
      });
  }
  public delete(url:string, isOData:boolean = true) {
    let options = this.setOption();
    this.pendingRequests++;

    return this.http.delete(url, options)
      .map((res:any) => this.extractData(res, isOData, true))
      .catch((error)=> {
        return this.handleError(error, this.httpHandlerService)
      });
  }
  public postWithHeader(url:string, data:any,headerItems:Array<any>) {

    this.pendingRequests++;
    let options = this.setOption();
    if(headerItems)
    headerItems.forEach(function(item){
      options.headers.append(item.key,item.value);
    });

    return this.http.post(url, data, options)
      .map((res:any) => this.extractData(res, false, true))
      .catch((error)=> {
        return this.handleError(error, this.httpHandlerService)
      });


  }

  public get(url:string, isOData:boolean = true) {
    let options = this.setOption();
    this.pendingRequests++;

    return this.http.get(url, options)
      .map((res:any) => this.extractData(res, isOData, true))
      .catch((error)=> {
        return this.handleError(error, this.httpHandlerService)
      });
  }


  private extractData(res:any, isOData:boolean, isList:boolean) {
    this.pendingRequests--;
    this.httpHandlerService.handleMessage(res);
    let body = res;
    try {
      body = res.json();
    } catch (e) {
    }
    return body;

  }
  setAsLoggedout() {
    //setting the loggedIn flag in cache
    this.cachUtil.storeInCache(this.loggedInCachKey, false);
    //removing the user data from cache
    this.cachUtil.removeFromCache(this.accountCachKey);
    //removing jWT token
    this.cachUtil.removeFromCache('jhi-authenticationToken');
  }
  private handleError(error:Response | any, httpHandler:HttpHandlerService):any {

    this.pendingRequests--;
    if(error && error.status==401)
    {
     this.setAsLoggedout();
    }else {
      httpHandler.handle(error);
    }

    // In a real world app, you might use a remote logging infrastructure
    let errMsg:string;
    if(error.status=='0')
    {
      errMsg='error.NO_CONNECTION_ERROR';
    }
    //  this.httpHandlerService.handle(error)
    //if (error instanceof Response) {
    //  const body = error.json() || '';
    //  const err = body.error || JSON.stringify(body);
    //  errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    //} else {
    //  errMsg = error.message ? error.message : error.toString();
    //}
    //console.error(errMsg);
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/services/base-http-service.ts